export function rebuildLayout() {
  const bsw = document.querySelector(".bet-slip-wrapper");
  if (bsw) {
    const betslipHeight = bsw.clientHeight;
    // console.log(betslipHeight);
    document.querySelector(".app-container").style.minHeight = `${betslipHeight + 50}px`;
  }
};
